import React, { useState } from 'react';
import { Form, Input, Button, Card, notification, Typography } from 'antd';
import { useHistory } from 'react-router-dom';
import { forgetPassword } from '../../api/authApi';
import './ForgotPassword.css';

const { Text } = Typography;

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const { push } = useHistory();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await forgetPassword(values?.email);
      notification.success({
        placement: 'bottomRight',
        message: 'Password Reset Request Sent',
        description: 'Please check your email for further instructions.',
      });
      setTimeout(() => {
        push('/auth/login'); // Update the redirect path
      }, 1500);
    } catch (err) {
      notification.error({
        placement: 'bottomRight',
        message: 'Error',
        description: err.response?.data?.message || 'Failed to send reset password request.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-content">
        <Card
          style={{
            width: 500,
            padding: '50px 20px 20px',
            backgroundColor: '#fff',
          }}
        >
          <div style={{ textAlign: 'center', marginBottom: '24px' }}>
            <h1 style={{ fontSize: '24px', marginBottom: '8px', color: '#1890ff' }}>Forgot Password</h1>
            <Text style={{ color: '#666', fontSize: '14px' }}>
              Enter your email address and we'll send you a link to reset your password.
            </Text>
          </div>
          <Form layout="vertical" onFinish={onFinish}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  message: 'Email is required',
                  type: 'email',
                },
              ]}
            >
              <Input placeholder="Enter your email" />
            </Form.Item>
            <Button
              htmlType="submit"
              block
              type="primary"
              loading={loading}
              style={{ backgroundColor: '#1890ff', border: 'none' }}
            >
              Send Reset Link
            </Button>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPassword;
